[
  {
    "_note": "Civilisation traits (Phase 12a, ADR-0062). Each civilisation has two. Every effect has code behind it: buildingDiscount and unitDiscount take a percentage off a building's or unit's cost; sciencePercent adds to every city's science; goldPerCity adds gold in every city; centreFood adds food on every city's own tile; promotionPercent raises the chance a soldier is promoted after a win; seaMovement adds to every ship's movement; anarchyTurnsLess shortens a revolution.",
    "key": "scientific",
    "name": "Scientific",
    "summary": "Libraries, observatories, universities and research labs cost a quarter less; +10% science in every city.",
    "effects": {
      "buildingDiscount": {
        "library": 25,
        "observatory": 25,
        "university": 25,
        "research_lab": 25
      },
      "sciencePercent": 10
    }
  },
  {
    "key": "commercial",
    "name": "Commercial",
    "summary": "Markets, banks and stock exchanges cost a quarter less; +1 gold in every city.",
    "effects": {
      "buildingDiscount": {
        "market": 25,
        "bank": 25,
        "stock_exchange": 25
      },
      "goldPerCity": 1
    }
  },
  {
    "key": "militaristic",
    "name": "Militaristic",
    "summary": "Barracks cost half; soldiers who win are promoted half as often again.",
    "effects": {
      "buildingDiscount": {
        "barracks": 50
      },
      "promotionPercent": 50
    }
  },
  {
    "key": "expansionist",
    "name": "Expansionist",
    "summary": "Settlers and workers cost a quarter less, scouts half.",
    "effects": {
      "unitDiscount": {
        "settler": 25,
        "worker": 25,
        "scout": 50
      }
    }
  },
  {
    "key": "religious",
    "name": "Religious",
    "summary": "Temples and cathedrals cost half; a revolution lasts one turn less.",
    "effects": {
      "buildingDiscount": {
        "temple": 50,
        "cathedral": 50
      },
      "anarchyTurnsLess": 1
    }
  },
  {
    "key": "agricultural",
    "name": "Agricultural",
    "summary": "+1 food on every city's own tile; granaries and aqueducts cost a quarter less.",
    "effects": {
      "buildingDiscount": {
        "granary": 25,
        "aqueduct": 25
      },
      "centreFood": 1
    }
  },
  {
    "key": "seafaring",
    "name": "Seafaring",
    "summary": "Ships move one tile further and cost a fifth less.",
    "effects": {
      "unitDiscount": {
        "galley": 20,
        "caravel": 20,
        "galleon": 20,
        "frigate": 20,
        "ironclad": 20,
        "destroyer": 20,
        "transport": 20,
        "quinquereme": 20
      },
      "seaMovement": 1
    }
  }
]
